import { useState } from 'react';

export const useStatisticsFilters = () => {
  const [statsFilter, setStatsFilter] = useState<'all' | 'day' | 'month' | 'year' | 'custom'>('all');
  const [statsDateFrom, setStatsDateFrom] = useState<string>('');
  const [statsDateTo, setStatsDateTo] = useState<string>('');

  return {
    statsFilter,
    setStatsFilter,
    statsDateFrom,
    setStatsDateFrom,
    statsDateTo,
    setStatsDateTo
  };
};
